import React from "react";
import RadioButton from "./_components/RadioButton";

export default function RadioButtons({groupName, name, options, fieldName, onChange, value, classes = null }) {

  const radioButtons = options?.map((option, index) => (
    <RadioButton
      key={`RadioButton${groupName}_${index}`}
      id={index}
      groupName={groupName}
      name={name}
      option={option}
      onChange={e => {
        onChange(e.target.value);
      }}
      value={value}
    />
  ));

  return (
    <div className={"gc__radio_buttons_container " + classes} >
      {radioButtons}
    </div>
  );
};
